import { Component, OnInit } from '@angular/core';
import { MessageService, Message } from 'primeng/api';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ReportService } from 'src/app/services/report.service';
import {ValueAtRiskFilterDto} from 'src/app/reports/dto/report-filters-dto';

@Component({
  selector: 'value-at-risk',
  templateUrl: './value-at-risk.component.html'
})
export class ValueAtRiskComponent implements OnInit {
  myFilter: ValueAtRiskFilterDto;
  sortByList = [];
  /* myFilter: {
        fromDate: null,
        thruDate: null,
        fromTaxRateArea: string,
        thruTaxRateArea: string,
        fromDiffValue: number,
        thruDiffValue: number,
        bSortTRA: boolean,
    };  // filter object
   */

    displayState: any = {
        workingDiv: false,
    };

    constructor(private utilService: UtilitiesService, private messageService: MessageService,
                private reportService: ReportService) { }

    ngOnInit() {
        this.utilService.doAudit('onInit for Value-At-Risk component');
        // NOTE:  the id field value MUST match a column name in table(s) being queried
        this.sortByList = [
          {
            "id": "CaseNum",
            "desc": "Case #"
          },
          {
            "id": "PropTaxRateArea",
            "desc": "TRA"
          },
          {
            "id": "PropType",
            "desc": "Property Type"
          }];
        // initialize filter values coz the API doesn't accept nulls
        this.resetFilters();
    }

    // determine if user has specified any filters; should we validate some of the values (i.e. dates)??
    needVariables() {
        if (this.myFilter.fromDate || this.myFilter.thruDate || this.myFilter.fromTaxRateArea || this.myFilter.thruTaxRateArea || this.myFilter.fromDiffValue > 0) {
            return false;
        }
        return true;
    }

    resetFilters() {
        this.myFilter = {
            fromDate: null,
            thruDate: null,
            fromTaxRateArea: '',
            thruTaxRateArea: '',
            fromDiffValue: 0,
            thruDiffValue: 0,
            sortBy: ''
        };
    }

    runValueAtRiskReport() {
      let filterStr = this.genFilterStr(this.myFilter);
      // this.utilService.doAudit(this.myFilter, 'myFilter:');
      if (filterStr.length < 1) {
        this.showToast({key: 'toast', severity: 'info', detail: 'Please specify a value for at least ONE Selection Variable', summary: 'Info' });
        return;
      }
      this.displayState.workingDiv = true;
      this.reportService.getValueAtRisk(this.myFilter).subscribe(data => {
        this.utilService.doAudit(data,'got response from getValueAtRisk:');
        this.displayState.workingDiv = false;
        if (data) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        }
      });
    }

    private genFilterStr(filObj: any): string {
        // string FromDate, string ThruDate, string fromTRA, string thruTRA, int fromAmt, int thruAmt, bool bSortTRA
        let dtFields = ['fromDate', 'thruDate'];  // we'll need to convert Date values to acceptable format...
        let retStr = '';
        let propVal = '', dtIdx: number;
        for (let prop in filObj) {
            //console.log(prop);
            propVal = filObj[prop];
            if (propVal === null) { continue }
            dtIdx = dtFields.indexOf(prop);
            if (dtIdx > -1) {
                propVal = this.utilService.formatDate(propVal);
            }
            retStr = (retStr ? retStr + '&' : '') + prop + '=' + encodeURIComponent(propVal);
        }
        return retStr;
    }

    // Toaster-related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
        }

    clear() {
        this.messageService.clear();
    }
}
